export class proposalData  {
    title : string = '';
    firstName: string = '';
    lastName: string = '';
    mobileNo: string = '';
    emailId: string = '';
    dob : string = '';
    gender: string = '';
    addressLine1 : string = '';
    pincode : string = '';
    sumInsured: string = '';
    prospectId : string = '';
    quoteId : string = '';
    premium: string;
    insurerName: string;
    insuredMemberRelation1: string = 'SELF';
    insuredPersonTitle1: string = '';
    insuredPersonFirstName1: string = '';
    insuredPersonLastName1: string = '';
    insuredPersonDob1: string = '';
    insuredMemberRelation2: string = 'SPOUSE';
    insuredPersonTitle2: string = '';
    insuredPersonFirstName2: string = '';
    insuredPersonLastName2: string = '';
    insuredPersonDob2: string = '';
    insuredMemberRelation3: string = '';
    insuredPersonTitle3: string = '';
    insuredPersonFirstName3: string = '';
    insuredPersonLastName3: string = '';
    insuredPersonDob3: string = '';
    insuredMemberRelation4: string = '';
    insuredPersonTitle4: string = '';
    insuredPersonFirstName4: string = '';
    insuredPersonLastName4: string = '';
    insuredPersonDob4: string = '';
    nomineeTitle: string = '';
    nomineeFirstName: string = '';
    nomineeLastName: string = '';
    nomineeDob: string = '';
    nomineeRelationship1: string = '';
    authorizedSignatory: any;
    authorizedSignatoryDate: any;
    
    constructor() {
    }
}